import { jsx } from "react/jsx-runtime";
import { useRef, useMemo } from "react";
import PropTypes from "prop-types";
import { Menu } from "@reach/menu-button";
import { dropdownMenuContext } from "./dropdown-menu-context.es.js";
import { deprecated } from "../../prop-types-validators/deprecated.es.js";
const { Provider } = dropdownMenuContext;
const propTypes = {
  appearance: PropTypes.oneOf(["neat", "round"]),
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node).isRequired,
    PropTypes.func
  ]).isRequired,
  justify: PropTypes.oneOf(["start", "end"]),
  magnitude: deprecated(PropTypes.oneOf(["small", "medium", "large"])),
  placement: PropTypes.oneOf(["bottom", "left", "right", "top"]),
  spacing: deprecated(PropTypes.oneOf(["default", "none"]))
};
const defaultProps = {
  appearance: "neat",
  justify: "start",
  magnitude: void 0,
  placement: "bottom",
  spacing: void 0
};
const DropdownMenu = ({
  appearance,
  children,
  justify,
  magnitude,
  placement,
  spacing,
  ...restProps
}) => {
  const buttonRef = useRef();
  const contextValue = useMemo(
    () => ({
      appearance,
      buttonRef,
      justify,
      magnitude,
      placement,
      spacing
    }),
    [appearance, justify, magnitude, placement, spacing]
  );
  return /* @__PURE__ */ jsx(Provider, { value: contextValue, children: /* @__PURE__ */ jsx(Menu, { ...restProps, children }) });
};
DropdownMenu.propTypes = propTypes;
DropdownMenu.defaultProps = defaultProps;
export {
  DropdownMenu
};
